module.exports = __webpack_public_path__ + "static/media/acting.dc0af2f9.jpg";